import {
    BatchUpdateOrderRefundAmountParam,
    AsyncBatchUpdateOrderRefundAmountParam,
    BatchUpdatePriceVo,
    QueryOrderAfterSalesReturnInfoByDisOidParam,
    OrderAfterSalesReturnInfoVo,
    QueryOrderAfterSalesReturnParam,
    UpdateInvoiceSwitchParam,
    Void,
    QueryCompanyInvoiceConfigResult,
    UpdateCompanyInvoiceConfigParam,
    QueryInvoiceStrategyParams,
    QueryInvoiceStrategyResult,
    UpdateInvoiceStrategyParam,
    DeleteInvoiceStrategyParam,
    PageInvoiceStrategyParams,
    PageInvoiceStrategyResult,
    PageMyChannelsParams,
    PageMyChannelResult,
    QueryMyChannelInvoiceConfigParams,
    QueryChannelInvoiceConfigResult,
    QueryInvoiceFlagConfigParams,
    QueryInvoiceFlagConfigResult,
    ExportInvoiceInfoParam,
    ImportInvoiceParam,
    AsyncOperationResultVo,
    GetTaskProgressParams,
    AsyncProcessingResultObject,
    ApplyInvoicePreCheckParam,
    PushSettlementToSupplierParam,
    ApplyInvoicePreCheckResult,
    ApplyInvoiceParam,
    QueryInvoiceFlagConfigBySettlementTypeParams,
    CreateSettlementPayOrderParam,
    CreateSettlementPayOrderResult,
    QueryInvoicingInfoBySupplierParams,
    InvoicingInfoVo,
    PriceTaxDifferenceVo,
    ConfirmInvoiceParam,
} from '@servicesTypings/companyRequestV3'

import {
    UpdatePriceParam,
    QueryOrderSettlementsUsingGet1Params,
    OrderSettlementVo,
    QueryOrderSettlementPayInfoParam,
    OrderSettlementPayInfoVo,
    QueryOrderSettlementsUsingGetParams,
    SettlementStatusStatisticsVo,
    UpdateSettlementStatusParam,
    CheckExistWaitPushParam,
    BindPaymentVoucherParam,
    BindOuterPayIdParam,
    DeleteOrderSettlementParam,
    QueryExportSettlementLogListUsingGetParams,
    ExportSettlementLogVo,
    OrderSettleOpParam,
    QueryInvoicingInfoUsingGetParams,
    InvoicingInfo,
    ChangeInvoiceStatusParam,
    SettlementBillOutgoingProgressVo,
    SettlementGenerationInfoVo,
    QuerySettlementExportConditionsUsingGetParams,
    ExportSettlementProgressVo,
    OrderImportExportLogVo,
} from '@servicesTypings/companyRequest'
import { GoodsPriceModifyVo, ExcelTipsInfo, ErpDrpPriceByItemCodeAndChannelParam } from '@servicesTypings/goodsRequest'
import {
    QueryOrderSettlementDetailListUsingGet1Params,
    AbstractSettlementDetail,
    ExportSettlementBasicInfoUsingGetParams,
    ExcelExportVo,
    ExportSettlementUsingGetParams,
    QueryPendingSettlementOrders,
} from '@servicesTypings/towerRequest'
import {
    OrderSupplierVo,
    MyChannelOptionsUsingGet1Params,
    MyChannelOptions,
    ListUserUsingGet1Params,
    CompanyUserVo,
    QueryOptionsUsingGetParams,
    MyChannelSimpleResult,
    QueryOptionsUsingGet2Params,
    MySupplierSimpleInfoResult,
    MySupplierOptionsParam,
} from '@servicesTypings/drpRequest'
import { companyRequest, goodsRequest, drpRequest, towerRequest } from '@/utils/request'

// 查询结算单明细的导出日志
/**
 * 查询导出结算单日志列表
 */
export function queryStatementDetailLog(
    params: QueryExportSettlementLogListUsingGetParams,
): API.Res<ExportSettlementLogVo[]> {
    return companyRequest.get('/orderImportExportLog/queryExportSettlementLogList', { params })
}

/**
 * 查询我的供应商
 */
export function getSupplierOptionsApi(): API.Res<OrderSupplierVo[]> {
    return drpRequest.get('/myPartner/mySupplierOptions')
}

/**
 * 查询我的分销商
 */
export function getChannelOptionsApi(params: MyChannelOptionsUsingGet1Params): API.Res<MyChannelOptions[]> {
    return drpRequest.get('/myPartner/myChannelOptions', { params })
}

/**
 * 查询用户列表
 */
export function queryCreaterList(params: ListUserUsingGet1Params): API.Res<CompanyUserVo[]> {
    return drpRequest.get('/user/listUser', { params })
}

/**
 * 结算单支付
 */
export function statementPay(data: OrderSettleOpParam): API.Res<OrderSettleOpParam> {
    return companyRequest.post('/orderSettlement/pay', { data })
}

/**
 * 供销商充值V2 (转换包含中文无法完全转换)
 */
export function orderSettlementChargeV2(data: any): API.Res<boolean> {
    return companyRequest.post('/orderSettlement/chargeV2', { data })
}

// 查询开票信息
/**
 * 查询开票信息
 */
export function queryInvoicingInfo(params: QueryInvoicingInfoUsingGetParams): API.Res<InvoicingInfo[]> {
    return companyRequest.get('/invoicingInfo/queryInvoicingInfo', { params })
}

// 删除开票信息
/**
 * 删除开票信息
 */
export function deleteInvoicingInfo(data: InvoicingInfo): API.Res<object> {
    return companyRequest.post('/invoicingInfo/deleteInvoicingInfo', { data })
}

// 修改默认开票信息
/**
 * 修改默认开票信息
 */
export function updateDefaultInvoice(data: InvoicingInfo): API.Res<object> {
    return companyRequest.post('/invoicingInfo/updateDefaultInvoice', { data })
}

/**
 * 供应商驳回开票
 */
export function orderSettlementRefuseInvoice(data: ChangeInvoiceStatusParam): API.Res<null> {
    return companyRequest.post('/orderSettlement/refuseInvoice', { data })
}

// 保存开票信息
/**
 * 新增开票信息
 */
export function saveInvoicingInfo(data: InvoicingInfo): API.Res<string> {
    return companyRequest.post('/invoicingInfo/saveInvoicingInfo', { data })
}

/**
 * 供应商审核开票
 */
export function orderSettlementConfirmInvoice(data: ConfirmInvoiceParam): API.Res<null> {
    return companyRequest.post('/orderSettlement/confirmInvoice', { data })
}

// 分销商撤回开票
/**
 * 分销商撤回开票
 */
export function withdrawInvoice(data: ChangeInvoiceStatusParam): API.Res<null> {
    return companyRequest.post('/orderSettlement/withdrawInvoice', { data })
}

// 改价
/**
 * 改价
 */
export function settlementUpdatePrice(data: UpdatePriceParam): API.Res<null> {
    return companyRequest.post('/orderSettlementPriceChange/updatePrice', { data })
}

// 根据商品编码查询ERP基本售价
/**
 * 根据商品编码查询ERP基本售价
 */
export function queryErpBasePriceByItemCode(data: string[]): API.Res<GoodsPriceModifyVo[]> {
    return goodsRequest.post('/modifyPrice/queryErpBasePriceByItemCode', { data })
}

// 查询批量修改ERP基本售价提示说明
/**
 * 查询批量修改ERP基本售价提示说明
 */
export function queryUpdateBasePricesForErpSku(data: GoodsPriceModifyVo[]): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/modifyPrice/queryUpdateBasePricesForErpSku', { data })
}

// 批量修改Erp基本售价
/**
 * 批量修改Erp基本售价V2
 */
export function updateErpBasePrices(data: GoodsPriceModifyVo[]): API.Res<object> {
    return goodsRequest.post('/modifyPrice/updateErpBasePricesV2', { data })
}

// 分销商查询结算单统计数据
export const channelSettlementStats = () => drpRequest.get('/partner/channel/settlementStats')

// 供应商查询结算单统计数据
export const supplierSettlementStats = () => drpRequest.get('/partner/supplier/settlementStats')

// 分页查询订单结算单列表
/**
 * 分页查询供销结算单列表
 */
export function queryOrderSettlements(params: QueryOrderSettlementsUsingGet1Params): API.Res<OrderSettlementVo[]> {
    return companyRequest.get('/sup/settlement/queryOrderSettlements', { params })
}

// 根据id 查询相应的数据
/**
 * 查询结算支付单信息
 */
export function queryOrderDetailByIds(data: QueryOrderSettlementPayInfoParam): API.Res<OrderSettlementPayInfoVo> {
    return companyRequest.post('/orderSettlement/queryOrderSettlementPayInfo', { data })
}

// 分页查询分销结算单列表
/**
 * 分页查询订单结算单列表
 */
export function queryChannelOrderSettlements(
    params: QueryOrderSettlementsUsingGetParams,
): API.Res<OrderSettlementVo[]> {
    return companyRequest.get('/orderChannelSettlement/queryOrderSettlements', { params })
}

// 分销结算单状态统计
/**
 * 分销结算单状态统计
 */
export function settlementStatusStatistics(): API.Res<SettlementStatusStatisticsVo> {
    return companyRequest.get('/orderChannelSettlement/settlementStatusStatistics')
}

// 供销结算单状态统计
/**
 * 供销结算单状态统计
 */
export function supSettlementStatusStatistics(): API.Res<SettlementStatusStatisticsVo> {
    return companyRequest.get('/sup/settlement/settlementStatusStatistics')
}

// 结算单明细
/**
 * 结算单详情
 */
export function queryOrderSettlementDetailList(
    params: QueryOrderSettlementDetailListUsingGet1Params,
): API.Res<AbstractSettlementDetail[]> {
    return towerRequest.get('/settlement/queryOrderSettlementDetailList', { params })
}

// /api/inner/settlement/queryOrderSettlementDetailList
// 修改结算状态
/**
 * 修改结算状态
 */
export function updateSettlementStatus(data: UpdateSettlementStatusParam): API.Res<null> {
    return companyRequest.post('/orderSettlement/updateSettlementStatus', { data })
}

// 导出结算单基础信息
/**
 * 导出结算单基础信息
 */
export function exportSettlementBasicInfo(params: ExportSettlementBasicInfoUsingGetParams): API.Res<ExcelExportVo> {
    return towerRequest.get('/settlement/detail/exportSettlementBasicInfo', { params })
}

// 导出结算单
/**
 * 导出结算单
 */
export function exportSettlement(params: ExportSettlementUsingGetParams): API.Res<ExcelExportVo> {
    return towerRequest.get('/settlement/detail/exportSettlement', { params })
}

// 校验待推送
/**
 * 校验待推送
 */
export function checkExistWaitPush(data: CheckExistWaitPushParam): API.Res<null> {
    return companyRequest.post('/orderSettlement/checkExistWaitPush', { data })
}

// 导出供销待结算订单
/**
 * 导出待结算单
 */
export function exportSupAwaitSettlement(data: QueryPendingSettlementOrders): API.Res<ExcelExportVo> {
    return towerRequest.post('/settlement/exportSupAwaitSettlement', { data })
}

// 导出分销待结算订单
/**
 * 导出待结算单
 */
export function exportChannelAwaitSettlement(data: QueryPendingSettlementOrders): API.Res<ExcelExportVo> {
    return towerRequest.post('/settlement/exportChannelAwaitSettlement', { data })
}

// 导出供销待结算商品
/**
 * 导出供销待结算单基础信息
 */
export function exportAwaitSupSettlementBasicInfo(data: QueryPendingSettlementOrders): API.Res<ExcelExportVo> {
    return towerRequest.post('/settlement/exportAwaitSupSettlementBasicInfo', { data })
}

// 导出分销待结算商品
/**
 * 导出分销待结算单基础信息
 */
export function exportAwaitChannelSettlementBasicInfo(data: QueryPendingSettlementOrders): API.Res<ExcelExportVo> {
    return towerRequest.post('/settlement/exportAwaitChannelSettlementBasicInfo', { data })
}

// 绑定支付单
/**
 * 绑定支付单
 */
export function bindPaymentVoucher(data: BindPaymentVoucherParam): API.Res<boolean> {
    return companyRequest.post('/orderSettlement/bindPaymentVoucher', { data })
}

// 绑定外部支付单
/**
 * 绑定外部支付单
 */
export function bindOuterPayId(data: BindOuterPayIdParam): API.Res<boolean> {
    return companyRequest.post('/orderSettlement/bindOuterPayId', { data })
}

/**
 * 删除结算单
 */
export function deleteOrderSettlement(data: DeleteOrderSettlementParam): API.Res<boolean> {
    return companyRequest.post('/orderSettlement/deleteOrderSettlement', { data })
}

/**
 * 批量改价 (转换包含中文无法完全转换)
 */
export function batchUpdatePriceUsingPOST(data: any): API.Res<BatchUpdatePriceVo> {
    return companyRequest.post('/orderSettlementPriceChange/batchUpdatePrice', { data })
}

/**
 * 获取我的供应商列表
 */
export function queryOptionsUsingGET2(params: QueryOptionsUsingGet2Params): API.Res<MySupplierSimpleInfoResult[]> {
    return drpRequest.get('/mySupplier/queryOptions', { params })
}

/**
 * 根据商品编码和分销商查询分销价
 */
export function queryErpDrpPriceByItemCodeAndChannelUsingPOST(
    data: ErpDrpPriceByItemCodeAndChannelParam,
): API.Res<GoodsPriceModifyVo[]> {
    return goodsRequest.post('/modifyPrice/queryErpDrpPriceByItemCodeAndChannel', { data })
}

/**
 * 查询结算单出账进度
 */
export function querySettlementBillOutgoingProgressUsingPOST(
    data: string[],
): API.Res<SettlementBillOutgoingProgressVo> {
    return companyRequest.post('/orderSettlement/querySettlementBillOutgoingProgress', { data })
}

/**
 * 查询结算单导出条件
 */
export function querySettlementExportConditionsUsingGET(
    params: QuerySettlementExportConditionsUsingGetParams,
): API.Res<SettlementGenerationInfoVo> {
    return companyRequest.get('/orderSettlement/log/querySettlementExportConditions', { params })
}

/**
 * 查询导出进度
 */
export function queryExportProgressUsingPOST(data: string[]): API.Res<ExportSettlementProgressVo[]> {
    return companyRequest.post('/orderImportExportLog/queryExportProgress', { data })
}

/**
 * 根据ID查询导出结算单日志列表
 */
export function queryExportSettlementLogListByIdsUsingPOST(data: string[]): API.Res<ExportSettlementLogVo[]> {
    return companyRequest.post('/orderImportExportLog/queryExportSettlementLogListByIds', { data })
}

/**
 * 根据ID查询供销结算单信息
 */
export function queryOrderSettlementsByIdsUsingPOST1(data: string[]): API.Res<OrderSettlementVo[]> {
    return companyRequest.post('/sup/settlement/queryOrderSettlementsByIds', { data })
}

/**
 * 根据ID查询分销结算单信息
 */
export function queryOrderSettlementsByIdsUsingPOST(data: string[]): API.Res<OrderSettlementVo[]> {
    return companyRequest.post('/orderChannelSettlement/queryOrderSettlementsByIds', { data })
}

/**
 * 根据ID查询日志列表
 */
export function queryLogListByIdsUsingPOST(data: string[]): API.Res<OrderImportExportLogVo[]> {
    return companyRequest.post('/orderImportExportLog/queryLogListByIds', { data })
}

/**
 * 查询我的供应商
 */
export function queryOptionsForPostUsingPOST1(data: MySupplierOptionsParam): API.Res<MySupplierSimpleInfoResult[]> {
    return drpRequest.post('/mySupplier/queryOptionsForPost', { data })
}

/**
 * 查询我的分销商
 */
export function queryOptionsForPostUsingPOST(data: any): API.Res<MyChannelSimpleResult[]> {
    return drpRequest.post('/myChannel/queryOptionsForPost', { data })
}

/**
 * 批量修改订单实退金额（供应商使用）
 */
export function batchUpdateOrderRefundAmount(data: BatchUpdateOrderRefundAmountParam): API.Res<Boolean> {
    return companyRequest.post('/orderSettlementPriceChange/batchUpdateOrderRefundAmount', { data })
}

/**
 * 批量异步修改订单实退金额（供应商使用）
 */
export function asyncBatchUpdateOrderRefundAmount(
    data: AsyncBatchUpdateOrderRefundAmountParam,
): API.Res<BatchUpdatePriceVo> {
    return companyRequest.post('/orderSettlementPriceChange/asyncBatchUpdateOrderRefundAmount', { data })
}

/**
 * 根据分销商订单号查询订单售后退货信息
 */
export function queryOrderAfterSalesReturnInfoByDisOid(
    data: QueryOrderAfterSalesReturnInfoByDisOidParam,
): API.Res<OrderAfterSalesReturnInfoVo[]> {
    return companyRequest.post('/orderChannelSettlement/queryOrderAfterSalesReturnInfoByDisOid', { data })
}

/**
 * 根据供应商订单号查询订单售后退货信息
 */
export function queryOrderAfterSalesReturnInfo(
    data: QueryOrderAfterSalesReturnParam,
): API.Res<OrderAfterSalesReturnInfoVo[]> {
    return companyRequest.post('/sup/settlement/queryOrderAfterSalesReturnInfo', { data })
}

/**
 * 更新支持开票开关
 */
export function updateInvoiceSwitch(data: UpdateInvoiceSwitchParam): API.Res<Void> {
    return companyRequest.post('/invoiceConfig/updateInvoiceSwitch', { data })
}

/**
 * 查询商家维度开票默认配置
 */
export function queryCompanyInvoiceConfig(): API.Res<QueryCompanyInvoiceConfigResult> {
    return companyRequest.get('/invoiceConfig/queryCompanyInvoiceConfig')
}

/**
 * 更新商家维度开票配置
 */
export function updateCompanyInvoiceConfig(data: UpdateCompanyInvoiceConfigParam): API.Res<Void> {
    return companyRequest.post('/invoiceConfig/updateCompanyInvoiceConfig', { data })
}

/**
 * 查询商家是否开通在线支付
 */
export function canOnlinePay(): API.Res<Boolean> {
    return drpRequest.get('/company/canOnlinePay')
}

/**
 * 查询开票策略详情
 */
export function queryInvoiceStrategy(params: QueryInvoiceStrategyParams): API.Res<QueryInvoiceStrategyResult> {
    return companyRequest.get('/invoiceConfig/queryInvoiceStrategy', { params })
}

/**
 * 更新开票策略详情
 */
export function updateInvoiceStrategy(data: UpdateInvoiceStrategyParam): API.Res<Void> {
    return companyRequest.post('/invoiceConfig/updateInvoiceStrategy', { data })
}

/**
 * 删除开票策略详情
 */
export function deleteInvoiceStrategy(data: DeleteInvoiceStrategyParam): API.Res<Void> {
    return companyRequest.post('/invoiceConfig/deleteInvoiceStrategy', { data })
}

/**
 * 分页查询开票策略列表
 */
export function pageInvoiceStrategy(params: PageInvoiceStrategyParams): API.Res<PageInvoiceStrategyResult> {
    return companyRequest.get('/invoiceConfig/pageInvoiceStrategy', { params })
}

/**
 * 分页查询我的分销商列表
 */
export function pageMyChannels(params: PageMyChannelsParams): API.Res<PageMyChannelResult[]> {
    return companyRequest.get('/invoiceConfig/pageMyChannels', { params })
}

/**
 * 查询我的分销商列表开票配置
 */
export function queryMyChannelInvoiceConfig(
    params: QueryMyChannelInvoiceConfigParams,
): API.Res<QueryChannelInvoiceConfigResult[]> {
    return companyRequest.get('/invoiceConfig/queryMyChannelInvoiceConfig', { params })
}

/**
 * 查询在线开票配置-点击供应商在线开票标记
 */
export function queryInvoiceFlagConfig(params: QueryInvoiceFlagConfigParams): API.Res<QueryInvoiceFlagConfigResult> {
    return companyRequest.get('/invoiceConfig/queryInvoiceFlagConfig', { params })
}
/**
 * 查询在线开票配置-点击供应商在线开票标记
 */
export function queryInvoiceFlagConfigBySettlementType(
    params: QueryInvoiceFlagConfigBySettlementTypeParams,
): API.Res<QueryInvoiceFlagConfigResult> {
    return companyRequest.get('/invoiceConfig/queryInvoiceFlagConfigBySettlementType', { params })
}

/**
 * 导出开票信息
 */
export function exportInvoiceInfo(data: ExportInvoiceInfoParam): API.Res<string> {
    return companyRequest.post('/sup/settlement/exportInvoiceInfo', { data })
}

/**
 * 导入文件开票(图片/PDF/Excel)，通过invoiceType区分：EXCEL-导入Excel，PDF-上传文件（图片/PDF）
 */
export function importInvoice(data: ImportInvoiceParam): API.Res<AsyncOperationResultVo> {
    return companyRequest.post('/sup/settlement/importInvoice', { data })
}

/**
 * 查询异步任务进度和结果
 */
export function getTaskProgress(params: GetTaskProgressParams): API.Res<AsyncProcessingResultObject> {
    return companyRequest.get('/async/task/getTaskProgress', { params })
}

/**
 * 申请开票前置校验
 */
export function applyInvoicePreCheck(data: ApplyInvoicePreCheckParam): API.Res<ApplyInvoicePreCheckResult> {
    return companyRequest.post('/orderChannelSettlement/applyInvoicePreCheck', { data })
}
/**
 * 分销商申请开票
 */
export function applyInvoice(data: ApplyInvoiceParam): API.Res<null> {
    return companyRequest.post('/orderSettlement/applyInvoice', { data })
}

/**
 * 分销商申请开票
 */
export function applyInvoiceV2(data: ApplyInvoiceParam): API.Res<Void> {
    return companyRequest.post('/orderChannelSettlement/applyInvoice', { data })
}

/**
 * 创建分销结算支付单
 */
export function createSettlementPayOrder(data: CreateSettlementPayOrderParam): API.Res<CreateSettlementPayOrderResult> {
    return companyRequest.post('/orderSettlement/createSettlementPayOrder', { data })
}

/**
 * 查询开票信息
 */
export function queryInvoicingInfoBySupplier(params: QueryInvoicingInfoBySupplierParams): API.Res<InvoicingInfoVo> {
    return companyRequest.get('/invoicingInfo/queryInvoicingInfoBySupplier', { params })
}

/**
 * 查询价税差额
 */
export function queryChannelPriceTaxDifference(data: string[]): API.Res<PriceTaxDifferenceVo[]> {
    return companyRequest.post('/orderChannelSettlement/queryPriceTaxDifference', { data })
}
/**
 * 批量推送结算单给供应商
 */
export function pushSettlementToSupplier(data: PushSettlementToSupplierParam): API.Res<AsyncOperationResultVo> {
    return companyRequest.post('/orderChannelSettlement/pushSettlementToSupplier', { data })
}

/**
 * 查询价税差额
 */
export function querySupPriceTaxDifference(data: string[]): API.Res<PriceTaxDifferenceVo[]> {
    return companyRequest.post('/sup/settlement/queryPriceTaxDifference', { data })
}

/**
 * 供应商审核开票
 */
export function confirmInvoice(data: ConfirmInvoiceParam): API.Res<Boolean> {
    return companyRequest.post('/sup/settlement/confirmInvoice', { data })
}
